export default "__VITE_ASSET__k016qd$1__"